import React, { FC, ReactElement, ChangeEvent } from 'react';
import Tooltip from 'ui/Tooltip';

interface CheckboxProps {
  id: any;
  name: string;
  value: string;
  label: string;
  elementType: string;
  description: string;
  isChecked: boolean;
  withTooltip: boolean;
  action: (state: ChangeEvent<HTMLInputElement>, elementType: string, id?: number, question_id?: number) => void;
  formErrors: string;
  stylePreset?: any;
  errors?: string | boolean;
  question_id?: number;
};

// stylePreset:
//      no property             => no preset
//      'bordered'              => element with border (FinancialSurvey design)
// customStyles:
//      no property             => no custom styles object
//      { width: '100px' }      =>

const Checkbox: FC<CheckboxProps> = ({
  id,
  name,
  value,
  label,
  isChecked,
  withTooltip,
  elementType,
  description,
  action,
  formErrors,
  stylePreset,
  errors,
  question_id,
}: CheckboxProps): ReactElement => {
  const defineAdditionalClass = (style: string | undefined) => {
    switch (style) {
      case 'bordered':
        return 'isBordered';
      default:
        return '';
    }
  };

  const additionalClass = defineAdditionalClass(stylePreset);

  const uiElementType = elementType;

  const TooltipStyle = {
    position: 'absolute',
    top: '20px',
    right: '0',
    width: '300px',
    padding: '16px',
    borderRadius: '10px',
    textAlign: 'justify',
    backgroundColor: '#ffffff',
    boxShadow: '0 10px 30px rgba(58, 112, 191, 0.15)',
    zIndex: '100',
    fontSize: '12px',
    color: '#9EA9B9FF',
  };

  return (
    <div className="container-ui-item-box" style={{ position: 'relative' }}>
      <div className={`custom-checkbox ${additionalClass} ${isChecked ? 'isActive' : ''}`}>
        <label className={`custom-checkbox__label ${formErrors !== '' ? 'isError' : ''}`}>
          <input
            className="custom-checkbox__input"
            type="checkbox"
            id={id}
            name={name}
            value={value}
            checked={isChecked}
            onChange={(event: ChangeEvent<HTMLInputElement>) => action(event, uiElementType, id, question_id)}
          />
          <div className="custom-checkbox__checkmark" />
          <span className="custom-checkbox__label-text">{label}</span>
          {withTooltip ? (
            <Tooltip
              text={description}
              activationDelay={400}
              customStyle={{
                position: 'absolute',
                right: '10px',
              }}
              customTipStyle={TooltipStyle}
            >
              <svg
                className="custom-checkbox__tooltip-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.5817 0 0 3.5817 0 8C0 12.4183 3.5817 16 8 16C12.4183 16 16 12.4183 16 8C16 3.5817 12.4183 0 8 0ZM8 14.4C4.47103 14.4 1.6 11.529 1.6 8C1.6 4.47103 4.47103 1.6 8 1.6C11.529 1.6 14.4 4.47103 14.4 8C14.4 11.529 11.529 14.4 8 14.4ZM9.33333 10.6667H8.8V7.73333C8.8 7.29167 8.44167 6.93333 8 6.93333H6.93333C6.49167 6.93333 6.13333 7.29167 6.13333 7.73333C6.13333 8.175 6.49167 8.53333 6.93333 8.53333H7.2V10.6667H6.66667C6.225 10.6667 5.86667 11.025 5.86667 11.4667C5.86667 11.9083 6.225 12.2667 6.66667 12.2667H9.33333C9.775 12.2667 10.1333 11.9083 10.1333 11.4667C10.1333 11.025 9.775 10.6667 9.33333 10.6667ZM8 5.86667C8.58913 5.86667 9.06667 5.38907 9.06667 4.8C9.06667 4.21087 8.58913 3.73333 8 3.73333C7.41087 3.73333 6.93333 4.21087 6.93333 4.8C6.93333 5.38907 7.41087 5.86667 8 5.86667Z" />
              </svg>
            </Tooltip>
          ) : (
            <></>
          )}
        </label>
      </div>
      {errors ? <h1 className="input__error">Select one or more answers</h1> : <></>}
    </div>
  );
};

export default Checkbox;
